module.exports = __webpack_public_path__ + "img/logo6.9d261550.png";